import { LuChevronDown } from 'react-icons/lu'
import {
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	Icon,

} from '@chakra-ui/react'

const TableList = ({ list, getPage }) => {


	return (


		<TableContainer width="100%">
			<Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
				<Thead >
					<Tr>

						<Th>Account Name</Th>
						<Th>Host</Th>
						<Th>Username</Th>
						<Th>Password</Th>


						<Th>Status</Th>
						<Th></Th>




					</Tr>
				</Thead>

				<Tbody fontSize="14px">
					{list.map((rs, index) => {

						const configData = JSON.parse(rs.api_config)

						return (

							<Tr key={index || rs?.id}>
								<Td>{rs.account_name}</Td>
								<Td>{configData.host}</Td>
								<Td>{configData.username}</Td>
								<Td>{configData.password}</Td>

								<Td>{rs.status_id === 1 ? "Active" : "InActive"}</Td>





								<Td style={{ color: "#0000EE" }}>
									<Menu>
										<MenuButton fontSize="14px" >
											Action

											<Icon as={LuChevronDown} />
										</MenuButton>

										<MenuList style={{ minWidth: "20px", border: "1px solid #CCCCCC" }}>
											<MenuItem h="16px" fontSize="12px" onClick={() => getPage('editEmail', '3', rs)} >Edit</MenuItem>
										</MenuList>
									</Menu>
								</Td>

							</Tr>

						)
					})}







				</Tbody>


			</Table>

		</TableContainer>

	)
}

export default TableList